export default __webpack_public_path__ + "static/media/iconEdit.b05757d0.svg";